export async function girisYap(istemci, giris) {
    return istemci.istek('/kimlik/giris', {
        method: 'POST',
        body: JSON.stringify(giris),
        yetkilendirme: false,
    });
}
export async function cikisYap(istemci, yenilemeJeton) {
    await istemci.istek('/kimlik/cikis', {
        method: 'POST',
        body: JSON.stringify({ yenilemeJeton }),
    });
}
export async function mevcutKullaniciAl(istemci) {
    return istemci.istek('/kimlik/ben');
}
//# sourceMappingURL=kimlik.js.map